$(document).ready(function () {
	let $form = $('form');

	if ($form.length) {
		$form.each(function () {
			let $self = $(this);

			$self.vegasFormSender({
				beforeSend: function (form) {
					vegasFormBeforeSend($(form).find('[type=submit]'));
				},
				success: function (data, form) {
					if (!data.error) {
						vegasFormAfterSend($(form).find('[type=submit]'));
						vegasFormSuccess(data.msg, form);
					} else {
						vegasFormError(data.msg)
					}
				},
				error: function (msg, form) {
					vegasFormAfterSend($(form).find('[type=submit]'));
					vegasFormError(msg);
				}
			});
		});
	}
});

function vegasFormBeforeSend($btn) {
	$btn.addClass('loading').attr('disabled', true).text($btn.data('text-send'));
}

function vegasFormAfterSend($btn) {
	$btn.removeClass('loading').attr('disabled', false).text($btn.data('text'));
}

function vegasFormSuccess(msg, $form) {
	let $modal = $('#modal-success');

	$modal.find('.msg').text(msg);
	$modal.modal('show');

	return false;
}

function vegasFormError(msg) {
	let $modal = $('#modal-error');

	$modal.find('.msg').text(msg);
	$modal.modal('show');

	return false;
}